// https://fonts.google.com/icons?selected=Material+Icons

enum MaterialIcon {
    Search = 'search',
    Edit = 'edit',
    Visibility = 'visibility',
    Delete = 'delete',
    Close = 'close',
    Error = 'error',
    ExpandMore = 'expand_more',
    Boat = 'directions_boat',
    Account = 'account_circle',
    Add = 'add',
    Send = 'send',
    Done = 'done',
    Filter = 'filter_alt'
}

export default MaterialIcon;